<div class="modal-content modal-info-conjuge-avalista">
  <div class="modal-header">
    <button
      type="button"
      (click)="close()"
      class="close"
      data-dismiss="modal"
      aria-label="Fechar"
    >
      <span aria-hidden="true">&times;</span>
    </button>

    <h4 class="modal-title modal-info-conjuge-avalista__title">Atenção</h4>
  </div>

  <div class="modal-body">
    <div class="modal-info-conjuge-avalista__sub">Você já está adicionando um Cônjuge como Avalista.</div>
    <div class="modal-info-conjuge-avalista__sub">Para adicionar um Cônjuge e um Avalista, altere a Relação do Avalista com o Cliente.</div>
  </div>
  <div class="modal-footer modal-info-conjuge-avalista__action">
    <button
      type="button"
      class="btn btn-app btn-primary"
      (click)="close()">
      Ok, entendi
    </button>
  </div>
</div>
